import { Link } from "react-router-dom";
import { popularAzCategories } from "@/mocks/azCategories";

export default function PopularCategoriesStrip() {
  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-8 md:px-6 md:py-10">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
              <i className="ri-fire-line text-lg"></i>
            </span>
            <div>
              <h2 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                Popular categories
              </h2>
              <p className="text-xs text-foreground-500 md:text-sm">
                The most-searched business types on the directory right now
              </p>
            </div>
          </div>
          <Link
            to="/categories"
            className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-700 transition-colors hover:text-primary-800 cursor-pointer"
          >
            Browse all categories
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {popularAzCategories.map((cat) => (
            <Link
              key={cat.name}
              to={`/directory?q=${encodeURIComponent(cat.name)}`}
              title={`Search listings for ${cat.name}`}
              className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-accent-300 cursor-pointer"
            >
              <div className="relative h-36 w-full overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} services across the Mysore region`}
                  title={`${cat.name} - Mysore Yellow Pages`}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>
                <span className="absolute bottom-3 left-3 flex h-10 w-10 items-center justify-center rounded-md bg-background-50/95 text-primary-700">
                  <i className={`${cat.icon} text-lg`}></i>
                </span>
                <span className="absolute bottom-3 right-3 inline-flex items-center whitespace-nowrap rounded-full bg-accent-500 px-2.5 py-1 text-xs font-bold text-foreground-950">
                  {cat.count}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-4">
                <h3 className="font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                  {cat.name}
                </h3>
                <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                  {cat.description}
                </p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-secondary-700">
                  Browse listings
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-arrow-right-line text-[13px] transition-transform duration-200 group-hover:translate-x-0.5"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}